import { computed } from "vue";
import {} from "@/api";
export function useHistoryContentStats(history) {
    const historySize = computed(() => { var _a, _b; return (_b = (_a = history.value) === null || _a === void 0 ? void 0 : _a.size) !== null && _b !== void 0 ? _b : 0; });
    const numItemsActive = computed(() => { var _a, _b, _c; return (_c = (_b = (_a = history.value) === null || _a === void 0 ? void 0 : _a.contents_active) === null || _b === void 0 ? void 0 : _b.active) !== null && _c !== void 0 ? _c : 0; });
    const numItemsDeleted = computed(() => { var _a, _b, _c; return (_c = (_b = (_a = history.value) === null || _a === void 0 ? void 0 : _a.contents_active) === null || _b === void 0 ? void 0 : _b.deleted) !== null && _c !== void 0 ? _c : 0; });
    const numItemsHidden = computed(() => { var _a, _b, _c; return (_c = (_b = (_a = history.value) === null || _a === void 0 ? void 0 : _a.contents_active) === null || _b === void 0 ? void 0 : _b.hidden) !== null && _c !== void 0 ? _c : 0; });
    return {
        historySize,
        numItemsActive,
        numItemsDeleted,
        numItemsHidden,
    };
}
